interface FriendlyErrorLike {
  statusCode?: number;
  status?: number;
  response?: {
    status?: number;
  };
}

export const getFriendlyErrorMessageKey = (
  error: unknown,
  fallbackKey = 'errors.generic'
): string => {
  const apiError = error as FriendlyErrorLike | null;
  const statusCode = apiError?.statusCode ?? apiError?.status ?? apiError?.response?.status;

  if (statusCode === 0) {
    return 'errors.networkGeneric';
  }

  if (typeof statusCode === 'number' && statusCode >= 500) {
    return 'errors.serverGeneric';
  }

  return fallbackKey;
};

export const getFriendlyErrorMessage = (
  error: unknown,
  translate: (key: string) => string,
  fallbackKey = 'errors.generic'
): string => {
  return translate(getFriendlyErrorMessageKey(error, fallbackKey));
};
